<template>
  <div
    style="
      white-space: break-spaces !important;
      overflow-wrap: anywhere !important;
      text-align: justify !important;
    "
  >
    <div
      :class="align ? 'text-' + align : ''"
      v-html="
        text.length >= (length ? length : 75)
          ? isCollapsed
            ? `${text
                .replace(/\n/g, '<br \/>')
                .substr(0, length ? length : 75)}...`
            : text.replace(/\n/g, '<br \/>')
          : text.replace(/\n/g, '<br \/>')
      "
    />
    <b-button
      v-if="text.length > (length ? length : 75) && buttonType == 'button'"
      :variant="variant ? variant : 'flat-info'"
      size="sm"
      class="text-nowrap"
      @click="returnDataSms()"
      >{{ formatedBody }}</b-button
    >

    <small
      v-if="text.length > (length ? length : 75) && buttonType == 'span'"
      :class="variant ? 'text-' + variant : 'text-info'"
      class="text-nowrap cursor-pointer"
      @click="returnDataSms()"
      >{{ formatedBody + "..." }}</small
    >
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
    },
    length: {
      type: Number,
      required: false,
    },
    variant: {
      type: String,
      required: false,
    },
    buttonType: {
      type: String,
      default: "button",
    },
    align: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isCollapsed: true,
    };
  },
  computed: {
    formatedBody() {
      return this.isCollapsed == true ? "Show more" : "Show less";
    },
  },
  methods: {
    returnDataSms() {
      this.isCollapsed = !this.isCollapsed;
    },
  },
};
</script>